import { useState } from "react";
import { UploadCloud } from "lucide-react";

const Dropzone = ({ onFileUpload, multiple = false }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      onFileUpload?.(multiple ? files : files[0]);
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      onFileUpload?.(multiple ? files : files[0]);
    }
  };

  return (
    <label
      htmlFor="fileInput"
      className={`flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed p-6 text-center transition-all ${
        isDragging
          ? "border-green-500 bg-green-50 dark:border-green-400 dark:bg-green-900/20"
          : "border-gray-300 bg-gray-50 hover:border-green-400 dark:border-gray-700 dark:bg-gray-900 dark:hover:border-green-500/50"
      }`}
      onDragEnter={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onDrop={handleDrop}
    >
      <UploadCloud className="mb-2 h-8 w-8 text-green-500" />
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Arraste e solte seu arquivo aqui ou clique para selecionar
      </p>

      <input
        id="fileInput"
        type="file"
        className="hidden"
        multiple={multiple}
        onChange={handleFileSelect}
      />
    </label>
  );
};

export default Dropzone;
